module.exports = __webpack_public_path__ + "img/module-icon.9ea790fb.svg";